import ShortLink from '@admin/components/shortlink'
import Details from '@admin/components/details'
import Button from '@admin/components/button'
import Panel from '@admin/components/panel'
import PropTypes from 'prop-types'
import Edit from './edit'
import React from 'react'

const Overview = ({ agency }, { admin, provider }) => {

  const shortlink = {
    shortlink: agency.shortlink,
    text: 't(Share this signup page)',
    title: 't(Agency Signup Page)'
  }

  const library_url = `${provider.admin_host}/${admin.team.subdomain}/contentlibrary`

  const library = {
    label: library_url,
    className: 'link',
    link: library_url
  }

  const details = {
    before: <ShortLink { ...shortlink } />,
    sections: [
      {
        title: 't(Agency Details)',
        items: [
          { label: 't(Title)', content: agency.team.title },
          { label: 't(Perspectives)', content: agency.perspectives?.join(', ') || null },
          { label: 't(Languages)', content: agency.languages?.join(', ') || null },
          { label: 't(Admins)', content: agency.admins.length > 0 ? agency.admins.map((admin,index) => (
            <div key={`admin_${index}`}>{ admin.full_name }</div>
          )) : null },
          { label: 't(Public Library)', content: <Button { ...library } /> }
        ]
      },
      {
        title: 't(Translation Restrictions)',
        items: [
          { label: 't(Phrases)', content: agency.config.translation_restrictions?.length > 0 ? agency.config.translation_restrictions.map((restriction,index) => (
            <div key={`restriction_${index}`}>"{ restriction.phrase }"</div>
          )) : null }
        ]
      },
      {
        title: 't(Preview Messages)',
        items: [
          { label: 't(Email)', content: (
            <div className="truevail-preview-message" dangerouslySetInnerHTML={{ __html: agency.config.email_preview_message }} />
          ) },
          { label: 't(Social Media)', content: (
            <div className="truevail-preview-message" dangerouslySetInnerHTML={{ __html: agency.config.social_preview_message }} />
          ) }
        ]
      }
    ]
  }

  return <Details { ...details } />

}

Overview.contextTypes = {
  admin: PropTypes.object,
  provider: PropTypes.object
}

Overview.propTypes = {
  agency: PropTypes.object
}

const mapPropsToPanel = (props, context) => ({
  title: 't(Overview)',
  panel: <Overview agency={ props.agency } />,
  tasks: {
    items: [
      {
        label: 't(Edit Agency)',
        svg: 'square_pen',
        modal: <Edit agency={ props.agency } />
      }
    ]
  }
})

export default Panel(null, mapPropsToPanel)
